module.exports = __webpack_public_path__ + "static/tagging_screen@3x-46aec2ec0f05d7774133f5099c2bb87a.png";